if (!customElements.get('product-accordions')) {
  class ProductAccordions extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const accordions = this.querySelectorAll('.product-accordion');

      this.querySelectorAll('.js-read-more')
        .forEach((el) => el.addEventListener('click',
          (event) => {
            event.preventDefault();
            el.closest('.accordion__content').toggleAttribute('is-open');
          }
      ));
    }
  }
  customElements.define('product-accordions', ProductAccordions);
}
